export const SIGNALING = 'signaling' //Sinalização
export const BOILERMAKING_LOCKSMITHING = 'boilermaking_locksmithing' //Caldeiraria/Serralheria
export const CONSTRUCTION_LAYOUT = 'construction_layout' //Construção Civil/Layout
export const SECURITY_DEVICES = 'security_devices' //Dispositivos de Segurança
export const ELECTRIC = 'electric' //Elétrica
export const PAINTING = 'painting' //Pintura
